<template>
  <div class="row">
    <div class="col-3">
      <!-- Resumo de tabelas grid-->
      <!-- Resumo de tabelas grid-->
      <!-- Resumo de tabelas grid-->
      <label class="ml-3" for="input-filial">Resumo de tabelas</label>
      <b-row id="id-encerramento" cols="12" class="ml-3 mt-2 mb-2 pb-4">
        <b-col cols="3">
          <label for="input-live">Qtd tabelas</label>
          <b-input-group-text readonly>{{ tabelas.length }}</b-input-group-text>
        </b-col>

        <b-col cols="3">
          <label for="input-live">Sem carros</label>
          <b-input-group-text readonly>
            {{ tabelas.filter((tabela) => !tabela.carro).length }}
          </b-input-group-text>
        </b-col>

        <b-col cols="3">
          <label for="input-live">Sem Mot</label>
          <!-- {{solicitante.id_funcionario_erp}} -->
          <b-input-group-text readonly>
            {{ tabelas.filter((tabela) => !tabela.registro_mt1).length }}
          </b-input-group-text>
        </b-col>

        <b-col cols="3">
          <label for="input-live">Sem Cob</label>
          <!-- {{solicitante.id_funcionario_erp}} -->
          <b-input-group-text readonly>
            {{ tabelas.filter((tabela) => !tabela.registro_cob1).length }}
          </b-input-group-text>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" class="m-3">
          <label for="input-busca">Pesquisa no grid</label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder=" Tabela / carro ou operador"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-form>
        <div class="d-flex justify-content-center mb-3">
          <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
        </div>
        <!--tbl de dados -->
        <b-table
          id="tbltabelas"
          class="m-3"
          small
          hover
          striped
          sticky-header="580px"
          :items="itemsFiltered"
          :fields="tabelasgrid"
        >
          <template slot="cell(actions)" slot-scope="data">
            <b-button
              @click="editTabela(data.item)"
              v-b-modal.modal-multi-corretiva
              title="Editar tabela"
              size="sm"
              variant="success"
              class="mr-2"
            >
              <i class="fa fa-exclamation-circle"></i>
            </b-button>

            <b-button
              @click="editTabela(data.item), loadQuadroHorario()"
              v-b-modal.modal-multi-quadrohorario
              title="Quadro de horários"
              size="sm"
              variant="primary"
              class="mr-2"
            >
              <i class="fa fa-bus"></i>
            </b-button>
          </template>
        </b-table>
      </b-form>
    </div>

    <div class="col-9">
      <!-- Cadastro de tabelas-->
      <!-- Cadastro de tabelas-->
      <!-- Cadastro de tabelas-->
      <div class="atividades-rfilancamentos ml-4 mr-4">
        <b-form>
          <label for="input-filial">Empresa</label>
          <b-row id="id-encerramento" cols="12" class="mt-2 mb-2 p-2">
            <!--empresa -->
            <b-col cols="3">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="empresa"
                  v-model="tabela.id_empresa"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                  @change="loadFiliais()"
                >
                </b-form-select>
              </div>
            </b-col>

            <!--fILIAL -->
            <b-col cols="3">
              <label for="input-filial">Filial</label> {{ valor_filial }}
              <div>
                <b-form-select
                  id="empresa"
                  v-model="valor_filial"
                  required
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                  @change="loadLinhas()"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- linhas-->
            <b-col cols="1">
              <label for="input-filial">Linha</label>
              <div>
                <b-form-select
                  id="linha"
                  v-model="tabela.id_linha"
                  required
                  :options="linhas"
                  class="mb-3"
                  text-field="linha"
                >
                </b-form-select>
              </div>
            </b-col>

            <!--Periodo -->
            <b-col cols="2">
              <label for="input-filial">Período</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_periodo"
                  required
                  :options="periodos"
                  class="mb-3"
                  text-field="periodo"
                >
                </b-form-select>
              </div>
            </b-col>

            <!--Tipo de dia -->
            <b-col cols="2">
              <label for="input-filial">Tipo de Dia</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_dia"
                  required
                  :options="tipodias"
                  class="mb-3"
                  text-field="dia"
                  @change="loadTabelas()"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- Vigência -->
            <b-col cols="2">
              <div>
                <label for="datepicker-placeholder">Vigência</label>

                <b-form-datepicker
                  id="datepicker-placeholder"
                  required
                  v-model="tabela.dt_vigencia"
                  placeholder="Data da vigência"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>
          </b-row>

          <!-- Escala dados -->
          <!-- fechamento -->
          <label for="input-filial">Escala</label>
          <b-row id="id-encerramento" cols="12" class="mt-2 mb-2 p-2">
            <!--Serviço inicio-->
            <b-col cols="2">
              <label for="servico-inicio">Serviço início</label>
              <div>
                <b-form-input
                  id="ini-servico"
                  v-model="tabela.jornada_inicio"
                  type="time"
                ></b-form-input>
              </div>
            </b-col>

            <!--Serviço fim-->
            <b-col cols="2">
              <label for="servico-inicio">Serviço fim</label>
              <div>
                <b-form-input
                  id="ini-servico"
                  v-model="tabela.jornada_termino"
                  type="time"
                ></b-form-input>
              </div>
            </b-col>

            <!--Operação incio-->
            <b-col cols="2">
              <label for="servico-inicio">Operação inicio</label>
              <div>
                <b-form-input
                  id="ini-servico"
                  v-model="tabela.linha_inicio"
                  type="time"
                ></b-form-input>
              </div>
            </b-col>

            <!--Operação fim-->
            <b-col cols="2">
              <label for="servico-inicio">Operação fim</label>
              <div>
                <b-form-input
                  id="ini-servico"
                  v-model="tabela.linha_termino"
                  type="time"
                ></b-form-input>
              </div>
            </b-col>

            <!--refeição incio-->
            <b-col cols="2">
              <label for="servico-inicio">Refeição início</label>
              <div>
                <b-form-input
                  id="ini-servico"
                  v-model="tabela.refeicao_inicio"
                  type="time"
                ></b-form-input>
              </div>
            </b-col>

            <!--refeição fim-->
            <b-col cols="2">
              <label for="servico-inicio">Refeição fim</label>
              <div>
                <b-form-input
                  id="ini-servico"
                  v-model="tabela.refeicao_termino"
                  type="time"
                ></b-form-input>
              </div>
            </b-col>
          </b-row>

          <!-- Escala dados2 -->
          <!-- fechamento -->
          <b-row id="id-encerramento" cols="12" class="mt-2">
            <b-col cols="1">
              <label for="input-live">Tabela</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                v-model="tabela.tabela"
                required
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="1">
              <label for="input-live">Carro</label>
              <b-form-input
                @keyup.enter="loadVeiculo()"
                v-model="tabela.carro"
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="1">
              <label for="input-live">Placa</label>
              <b-input-group-text
                >{{
                  veiculos.map((mt1) => mt1.placa).join(", ")
                    ? veiculos.map((mt1) => mt1.placa).join(", ")
                    : "-"
                }}
              </b-input-group-text>
            </b-col>
            <b-col cols="1">
              <label for="input-live">Féria</label>
              <!--  {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                v-model="tabela.entrega_feria"
                placeholder=""
              ></b-form-input>
            </b-col>

            <!-- -->
            <b-col cols="2">
              <label for="input-sentido_ini">Sentido inicial</label>
              {{ tabela.id_sentido_inicio }}
              <div>
                <b-form-select
                  id="sentido_ini"
                  v-model="tabela.id_sentido_inicio"
                  required
                  :options="sentidos"
                  class="mb-3"
                  text-field="sentido"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- -->
            <b-col cols="2">
              <label for="input-sentido_fim">Sentido Término</label>
              <div>
                <b-form-select
                  id="sentido_fim"
                  v-model="tabela.id_sentido_termino"
                  required
                  :options="sentidos"
                  class="mb-3"
                  text-field="sentido"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="1">
              <b-form-checkbox
                id="cobrador"
                class="mb-3 mt-5"
                name="cobrador"
                value="true"
                v-model="tabela.tem_cobrador"
                unchecked-value="false"
                checked="true"
              >
                Cobrador
                <!-- --{{rfilancamento.lavador}} -->
              </b-form-checkbox>
            </b-col>

            <b-col cols="1">
              <b-form-checkbox
                id="ativo"
                class="mb-3 mt-5"
                name="status"
                value="true"
                v-model="tabela.status"
                unchecked-value="false"
                checked="true"
              >
                Tabela ativa
                <!-- --{{rfilancamento.lavador}} -->
              </b-form-checkbox>
            </b-col>

            <b-col cols="2">
              <b-form-checkbox
                id="noturno"
                class="mb-3 mt-5"
                name="notruno"
                v-model="tabela.noturno"
                value="true"
                unchecked-value="false"
                checked="true"
              >
                Virada de dia
              </b-form-checkbox>
            </b-col>
          </b-row>

          <!-- Motorista dados -->
          <!-- fechamento -->
          <label for="input-motorista">Motorista</label>
          <b-row id="id-encerramento" cols="12" class="mt-2">
            <b-col cols="1">
              <label for="input-live">1º Mot RE</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                @keyup.enter="loadBuscaMotorista1()"
                v-model="tabela.registro_mt1"
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">1º Motorista Nome</label>
              <b-input-group-text readonly>
                {{
                  motoristas1.map((mt1) => mt1.nome).join(", ")
                    ? motoristas1.map((mt1) => mt1.nome).join(", ")
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="1">
              <label for="input-live">1º Mot C.N.H</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input readonly placeholder=""></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-filial">Folga 1º mot</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.folga_mt1_id"
                  @input="getTipoDeFolgaMot1()"
                  @change="
                    postTipoDeFolgaOperador(motoristas1[0], tabela.folga_mt1_id)
                  "
                  :options="tipodefolgasMot1"
                  class="mb-3"
                  text-field="folga"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="1">
              <label for="input-live">2º Mot RE</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                @keyup.enter="loadBuscaMotorista2()"
                v-model="tabela.registro_mt2"
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">2º Mot Nome</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-input-group-text readonly>{{
                motoristas2.map((mt2) => mt2.nome).join(", ")
                  ? motoristas2.map((mt2) => mt2.nome).join(", ")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="1">
              <label for="input-live">2º Mot C.N.H</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input readonly placeholder=""></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-filial">Folga 2º mot</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.folga_mt2_id"
                  @input="getTipoDeFolgaMot2()"
                  @change="
                    postTipoDeFolgaOperador(motoristas2[0], tabela.folga_mt2_id)
                  "
                  :options="tipodefolgasMot2"
                  class="mb-3"
                  text-field="folga"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Minutos motorista </label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                v-model="tabela.motorista_tempo_minuto"
                placeholder=""
              ></b-form-input>
            </b-col>

            <!-- -->
            <b-col cols="3">
              <label for="input-filial">Pegada</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_motorista_pegada"
                  :options="pontos"
                  class="mb-3"
                  text-field="ponto"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- -->
            <b-col cols="3">
              <label for="input-filial">Largada</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_motorista_largada"
                  :options="pontos"
                  class="mb-3"
                  text-field="ponto"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Cobrador dados -->
          <!-- fechamento -->
          <label for="input-filial">Cobrador</label>
          <b-row id="id-encerramento" cols="12" class="mt-2">
            <b-col cols="1">
              <label for="input-live">1º Cob RE</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                @keyup.enter="loadBuscaCobrador1()"
                v-model="tabela.registro_cob1"
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">1º Cobrador Nome</label>
              <b-input-group-text readonly>
                {{
                  cobradores1.map((cb1) => cb1.nome).join(", ")
                    ? cobradores1.map((cb1) => cb1.nome).join(", ")
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-filial">Folga 1º cob</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.folga_cb1_id"
                  @input="getTipoDeFolgaCob1()"
                  @change="
                    postTipoDeFolgaOperador(cobrador1[0], tabela.folga_cb1_id)
                  "
                  :options="tipodefolgasCob1"
                  class="mb-3"
                  text-field="folga"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="1">
              <label for="input-live">2º Cob</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                @keyup.enter="loadBuscaCobrador2()"
                v-model="tabela.registro_cob2"
                placeholder=""
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">2º Cob Nome</label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-input-group-text readonly>
                {{
                  cobradores2.map((cb2) => cb2.nome).join(", ")
                    ? cobradores2.map((cb2) => cb2.nome).join(", ")
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-filial">Folga 2º cob</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.folga_cb2_id"
                  @input="getTipoDeFolgaCob2()"
                  @change="
                    postTipoDeFolgaOperador(cobrador2[0], tabela.folga_cb2_id)
                  "
                  :options="tipodefolgasCob2"
                  class="mb-3"
                  text-field="folga"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Minutos cobrador </label>
              <!-- {{solicitante.id_funcionario_erp}} -->
              <b-form-input
                v-model="tabela.cobrador_tempo_minuto"
                placeholder=""
              ></b-form-input>
            </b-col>

            <!-- -->
            <b-col cols="3">
              <label for="input-filial">Pegada</label>
              {{ tabela.id_cobrador_pegada }}
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_cobrador_pegada"
                  :options="pontos"
                  class="mb-3"
                  text-field="ponto"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- -->
            <b-col cols="3">
              <label for="input-filial">Largada</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_cobrador_largada"
                  :options="pontos"
                  class="mb-3"
                  text-field="ponto"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Gravar tabela -->
          <b-row>
            <b-button
              class="mt-3"
              variant="success"
              block
              @click="postTabela(), loadTabelas()"
              >Gravar</b-button
            >
          </b-row>
        </b-form>

        <div class="d-flex justify-content-center mb-3">
          <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
        </div>

        <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
        <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
        <div>
          <b-modal
            id="modal-multi-quadrohorario"
            cancel-title="Fechar"
            ok-title="Gravar"
            size="xl"
            title="Programação de horários "
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
          >
            <!-- -->
            <div>
              <b-row>
                <input id="id-sac" type="hidden" v-model="tabela.id" />

                <b-col cols="2" class="mt-5">
                  <label for="input-live">Linha</label>
                  <b-form-input
                    id="tabela-linha"
                    v-model="tabela.linha"
                    readonly
                    placeholder=""
                    class="mb-3"
                  ></b-form-input>
                </b-col>

                <b-col cols="2" class="mt-5">
                  <label for="input-live">Tipo de dia</label>
                  <b-form-input
                    id="tabela-linha"
                    v-model="tabela.dia"
                    readonly
                    placeholder=""
                    class="mb-3"
                  ></b-form-input>
                </b-col>

                <b-col cols="2" class="mt-5">
                  <label for="input-live">Jornada inicio</label>
                  <b-form-input
                    id="tabela-jini"
                    v-model="tabela.jornada_inicio"
                    readonly
                    placeholder=""
                    class="mb-3"
                  ></b-form-input>
                </b-col>

                <b-col cols="2" class="mt-5">
                  <label for="input-live">Refeição inicio</label>
                  <b-form-input
                    id="tabela-tabela"
                    v-model="tabela.refeicao_inicio"
                    readonly
                    placeholder=""
                    class="mb-3"
                  ></b-form-input>
                </b-col>

                <b-col cols="2" class="mt-5">
                  <label for="input-live">Refeição término</label>
                  <b-form-input
                    id="tabela-tabela"
                    v-model="tabela.refeicao_termino"
                    readonly
                    placeholder=""
                    class="mb-3"
                  ></b-form-input>
                </b-col>

                <b-col cols="2" class="mt-5">
                  <label for="input-live">Jornada término</label>
                  <b-form-input
                    id="tabela-jter"
                    v-model="tabela.jornada_termino"
                    readonly
                    placeholder=""
                    class="mb-3"
                  ></b-form-input>
                </b-col>
              </b-row>

              <!-- Tratativas -->
              <div class="d-flex justify-content-center mb-3">
                <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
              </div>
              <!--tbl de dados quadro de horário-->
              <b-table
                id="tblquadrodehorario"
                small
                hover
                striped
                sticky-header="330px"
                :items="quadrohorarios"
                :fields="qdhorario"
              >
                <template slot="cell(actions)" slot-scope="data">
                  <b-button
                    @click="editQuadroHorario(data.item)"
                    v-b-modal.modal-multi-corretiva
                    title="Editar tabela"
                    size="sm"
                    variant="primary"
                    class="mr-2"
                  >
                    <i class="fa fa-exclamation-circle"></i>
                  </b-button>
                </template>
              </b-table>

              <b-row>
                <b-col sm="12">
                  <label for="textarea-small">Quadro de horários:</label>

                  <b-row>
                    <!--Chegada-->
                    <b-col cols="2">
                      <label for="hr-chegada">Chegada</label>
                      <div>
                        <b-form-input
                          id="hr-chegada"
                          v-model="quadrohorario.chegada"
                          type="time"
                        ></b-form-input>
                      </div>
                    </b-col>

                    <!--Saida-->
                    <b-col cols="2">
                      <label for="hr-saida">Saída</label>
                      <div>
                        <b-form-input
                          id="hr-chegada"
                          v-model="quadrohorario.saida"
                          type="time"
                        ></b-form-input>
                      </div>
                    </b-col>

                    <!--Legenda -->
                    <b-col cols="2">
                      <label for="input-legenda">Legenda</label>
                      <div>
                        <b-form-select
                          id="legenda"
                          v-model="quadrohorario.id_legenda"
                          required
                          :options="legendas"
                          class="mb-3"
                          text-field="legenda"
                        >
                        </b-form-select>
                      </div>
                    </b-col>

                    <b-col cols="2">
                      <label for="input-filial">Local</label>
                      <div>
                        <b-form-select
                          id="filial"
                          v-model="quadrohorario.local_id"
                          :options="pontos"
                          class="mb-3"
                          text-field="ponto"
                        >
                        </b-form-select>
                      </div>
                    </b-col>

                    <!--Sentido -->
                    <b-col cols="1">
                      <label for="input-sentido">Sentido</label>
                      <div>
                        <b-form-select
                          id="qt_sentido"
                          v-model="quadrohorario.id_sentido"
                          required
                          :options="sentidos"
                          class="mb-3"
                          text-field="sentido"
                        >
                        </b-form-select>
                      </div>
                    </b-col>

                    <b-col cols="1">
                      <b-form-checkbox
                        id="qd_cheg"
                        class="mb-3 mt-5 mr-3"
                        name="notruno"
                        v-model="quadrohorario.chegada_virada_do_dia"
                        value="true"
                        unchecked-value="false"
                        checked="true"
                        v-b-tooltip.hover.bottom
                        title="Chegada no dia seguinte D+1"
                      >
                        Ch_D+1
                      </b-form-checkbox>
                    </b-col>

                    <b-col cols="1">
                      <b-form-checkbox
                        id="qd_cheg"
                        class="mb-3 mt-5 mr-3"
                        name="notruno"
                        v-model="quadrohorario.saida_virada_do_dia"
                        value="true"
                        unchecked-value="false"
                        checked="true"
                        v-b-tooltip.hover.bottom
                        title="Saida no dia seguinte D+1"
                      >
                        Sa_D+1
                      </b-form-checkbox>
                    </b-col>

                    <b-col cols="1">
                      <b-form-checkbox
                        id="qd_status"
                        class="mb-3 mt-5 ml-0"
                        name="qd_status"
                        value="true"
                        v-model="quadrohorario.status"
                        unchecked-value="false"
                        checked="true"
                      >
                        Ativo
                        <!-- --{{rfilancamento.lavador}} -->
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-button
                class="mt-3"
                variant="success"
                block
                @click="postQuadroHorario(), loadQuadroHorario()"
                >Gravar</b-button
              >
            </div>
          </b-modal>
        </div>

        <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      </div>
    </div>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "PlanejamentoEscalaModelo",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      // const values = Object.values(obj);
      valores = this.tabelas.filter((item) => {
        return (
          item.tabela.indexOf(this.search) > -1 //|| item.carro.indexOf(this.search) >-1 //|| item.motorista1.indexOf(this.search) >-1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      tipodefolgasMot1: [],
      tipodefolgasMot2: [],
      tipodefolgasCob1: [],
      tipodefolgasCob2: [],
      mode: "save",
      carregando: false,
      atualizando: false,

      // 15/07/2023 as 12:24h
      empresas: [],
      tabela: {},
      tabelas: [],
      filiais: [],
      linhas: [],
      tipodias: [],
      periodos: [],
      sentidos: [],
      pontos: [],
      veiculos: [],
      motorista1: {},
      motoristas1: [],
      motorista2: {},
      motoristas2: [],
      cobrador1: {},
      cobradores1: [],
      cobrador2: {},
      cobradores2: [],
      veiculo: "",
      search: "",
      quadrohorario: [],
      quadrohorarios: [],
      legendas: [],
      selected: null,

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      tabelasgrid: [
        { key: "tabela", label: "Tabela", sortable: true },
        { key: "jornada_inicio", label: "jornada_inicio", sortable: true },
        { key: "jornada_termino", label: "jornada_termino", sortable: true },
        { key: "carro", label: "carro", sortable: true },
        { key: "registro_mt1", label: "Motorista", sortable: true },
        { key: "registro_cob1", label: "Cobrador", sortable: true },

        { key: "actions", label: "Ações" },
      ],

      qdhorario: [
        { key: "id", label: "id_qh", sortable: true },
        { key: "tabela", label: "Tabela", sortable: true },
        { key: "chegada", label: "Chegada", sortable: true },
        { key: "saida", label: "Saida", sortable: true },
        { key: "legenda", label: "Legenda", sortable: true },
        { key: "ponto", label: "Local", sortable: true },
        { key: "sentido", label: "Sentido", sortable: true },
        {
          key: "status",
          label: "Status",
          sortable: true,
          formatter: (value) => (value ? "Ativo" : "Cancelado"),
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
  },

  methods: {
    getTipoDeFolgaMot1() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/escala/tipofolga`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodefolgasMot1 = res.data.map((td) => ({
            ...td,
            value: td.id, // usado em componentes como <select>
            folga: td.folga, // reforça o campo se necessário
            tipo: td.tipo, // idem
          }));
        })
        .catch(showError);
    },

    postTipoDeFolgaOperador(operadorId, folgaId) {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        id_empresa_grupo: operadorId.id_grupo_empresa,
        id_filial: operadorId.id_filial_erp,
        tabela: operadorId.registro,
        funcionario_id: `${this.user.id_funcionario}`,
        psg: this.user.psg,
        operador_id: operadorId.id_funcionario,
        folga_id: folgaId,
      };
      const url = `${baseApiUrl}/escala/folgaoperador`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
          // incluir metodo para gravar a atividade folga
        })
        .catch(showError);
    },

    getTipoDeFolgaMot2() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/escala/tipofolga`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodefolgasMot2 = res.data.map((td) => ({
            ...td,
            value: td.id, // usado em componentes como <select>
            folga: td.folga, // reforça o campo se necessário
            tipo: td.tipo, // idem
          }));
        })
        .catch(showError);
    },

    getTipoDeFolgaCob1() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/escala/tipofolga`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodefolgasCob1 = res.data.map((td) => ({
            ...td,
            value: td.id, // usado em componentes como <select>
            folga: td.folga, // reforça o campo se necessário
            tipo: td.tipo, // idem
          }));
        })
        .catch(showError);
    },

    getTipoDeFolgaCob2() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/escala/tipofolga`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodefolgasCob2 = res.data.map((td) => ({
            ...td,
            value: td.id, // usado em componentes como <select>
            folga: td.folga, // reforça o campo se necessário
            tipo: td.tipo, // idem
          }));
        })
        .catch(showError);
    },
    //barra de progresso
    ready() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          //this.loadRfiLancamentos()
        }
      }, 1000);
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadLinhas() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/linha/cad`;
      axios
        .get(url, { params })
        .then((res) => {
          this.linhas = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadTipoDia() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/tipodia`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipodias = res.data.map((td) => {
            return { ...td, value: td.id, dia: td.dia }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadPeriodo() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/periodo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.periodos = res.data.map((per) => {
            return { ...per, value: per.id, periodo: per.periodo }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadSentido() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/sentido`;
      axios
        .get(url, { params })
        .then((res) => {
          this.sentidos = res.data.map((se) => {
            return { ...se, value: se.id, sentido: se.sentido }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadVeiculo() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        prefixo: `${this.tabela.carro}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.veiculos = res.data;
        })
        .catch(showError);
    },

    loadLocal() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/planejamento/local`;
      axios
        .get(url, { params })
        .then((res) => {
          this.pontos = res.data.map((po) => {
            return { ...po, value: po.id_ponto, ponto: po.ponto }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    async loadBuscaMotorista1() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.registro_mt1}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/folha/funcionario/busca`;

      try {
        const res = await axios.get(url, { params });

        // Como você só espera um motorista, diretamente atribui o valor
        this.motoristas1 = [res.data]; // Colocando dentro de um array
      } catch (error) {
        console.error("Erro ao carregar motoristas:", error);
      }
    },

    async loadBuscaMotorista2() {
      let params = {
        id_empresa: this.user.id_empresa,
        registro: this.tabela.registro_mt2,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/folha/funcionario/busca`;

      try {
        const res = await axios.get(url, { params });

        // Se a requisição for bem-sucedida (status 200)
        this.motoristas2 = [res.data]; // Atribui o motorista encontrado
        // Opcional: mostrar um toast de sucesso, se você tiver um 'defaultSuccess' no toasted
        // Vue.toasted.global.defaultSuccess({ msg: 'Motorista localizado com sucesso!' });
      } catch (error) {
        // <--- AQUI ESTÁ A MUDANÇA: o parâmetro do catch agora é 'error'
        this.motoristas2 = null; // Limpa o motorista se houver erro

        console.error("Erro ao carregar motoristas:", error); // Agora 'error' está definido
        showError(error); // <--- E aqui você chama sua função passando o 'error' capturado
      }
    },

    async loadBuscaCobrador1() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.registro_cob1}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/folha/funcionario/busca`;

      try {
        const res = await axios.get(url, { params });

        console.log("Resposta da API:", res.data);

        // Como você só espera um motorista, diretamente atribui o valor
        this.cobradores1 = [res.data]; // Colocando dentro de um array
      } catch (error) {
        console.error("Erro ao carregar motoristas:", error);
      }
    },

    async loadBuscaCobrador2() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.registro_cob2}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/folha/funcionario/busca`;

      try {
        const res = await axios.get(url, { params });

        console.log("Resposta da API:", res.data);

        // Como você só espera um motorista, diretamente atribui o valor
        this.cobradores2 = [res.data]; // Colocando dentro de um array
      } catch (error) {
        console.error("Erro ao carregar motoristas:", error);
      }
    },

    postTabela() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id: `${[this.tabela.id]}`,
        id_empresa_grupo: `${[this.user.id_empresa]}`,
        id_empresa: `${[this.tabela.id_empresa]}`,
        id_filial: `${[this.valor_filial]}`,
        id_linha: `${[this.tabela.id_linha]}`,
        tabela: `${[this.tabela.tabela]}`,
        id_tipo: `${[this.tabela.id_tipo]}`,
        id_periodo: `${[this.tabela.id_periodo]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        jornada_inicio: `${this.tabela.jornada_inicio}`,
        jornada_termino: `${[this.tabela.jornada_termino]}`,
        linha_inicio: `${[this.tabela.linha_inicio]}`,
        linha_termino: `${[this.tabela.linha_termino]}`,
        refeicao_inicio: `${[this.tabela.refeicao_inicio]}`,
        refeicao_termino: `${[this.tabela.refeicao_termino]}`,
        id_sentido_inicio: `${[this.tabela.id_sentido_inicio]}`,
        id_sentido_termino: `${[this.tabela.id_sentido_termino]}`,
        id_carro: `${this.veiculos.map((mt1) => mt1.id_veiculo).join(", ")}`, //{{motoristas1.map(mt1 => mt1.nome_completo).join(', ')
        id_motorista1: `${[this.motoristas1.map((mt1) => mt1.id_funcionario)]}`,
        id_motorista2: `${[this.motoristas2.map((mt2) => mt2.id_funcionario)]}`,
        id_motorista_pegada: `${[this.tabela.id_motorista_pegada]}`,
        id_motorista_largada: `${[this.tabela.id_motorista_largada]}`,
        entrega_feria: [this.tabela.entrega_feria]
          ? `${[this.tabela.entrega_feria]}`
          : 0,
        motorista_tempo_minuto: `${[this.tabela.motorista_tempo_minuto]}`,
        cobrador_tempo_minuto: `${[this.tabela.cobrador_tempo_minuto]}`,
        noturno: `${[this.tabela.noturno]}`,
        tem_cobrador: `${[this.tabela.tem_cobrador]}`,
        dt_vigencia: `${[this.tabela.dt_vigencia]}`,
        status: `${[this.tabela.status]}`,
        id_funcionario_cadastro: `${[this.user.id_funcionario]}`,
        id_funcionario_alteracao: `${[this.user.id_funcionario]}`,
        id_identificador: `${[this.tabela.id_identificador]}`, // id legenda da programação
        id_cobrador1: `${[this.cobradores1.map((cb1) => cb1.id_funcionario)]}`,
        id_cobrador2: `${[this.cobradores2.map((cb2) => cb2.id_funcionario)]}`,
        id_cobrador_pegada: `${[this.tabela.id_cobrador_pegada]}`,
        id_cobrador_largada: `${[this.tabela.id_cobrador_largada]}`,

        folga_cb1_id: `${[this.tabela.folga_cb1_id]}`,
        folga_cb2_id: `${[this.tabela.folga_cb2_id]}`,
        folga_mt1_id: `${[this.tabela.folga_mt1_id]}`,
        folga_mt2_id: `${[this.tabela.folga_mt2_id]}`,
      };

      const url = `${baseApiUrl}/planejamento/tabela`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
          //    console.log("feria " + this.tabela.entrega_feria);
          this.resetTabela();
          /*
                this.carregando = false;
                //this.resetTabela()
                this.pontos = res.data.map(tbl => {
                  return { id: tbl.id }                  
                })
                */
        })
        .catch(showError);
    },

    loadTabelas() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.tabela.id_linha}`,
        id_dia: `${this.tabela.id_dia}`, /// {{motoristas1.map(mt1 => mt1.nome_completo).join(', ')  }}
      };
      const url = `${baseApiUrl}/planejamento/tabelamodelo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tabelas = res.data.map((tabs) => {
            return { ...tabs };
          });
        })

        .catch(showError);
    },

    /////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////
    /// QUADRO DE HORÁRIOS

    loadLegenda() {
      let params = {
        psg: `${this.user.psg}`,
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/legenda`;
      axios
        .get(url, { params })
        .then((res) => {
          this.legendas = res.data.map((le) => {
            return { ...le, value: le.id, legenda: le.legenda }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    postQuadroHorario() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id: `${[this.quadrohorario.id]}`,
        id_tabela: `${[this.tabela.id]}`,
        id_empresa: `${[this.tabela.id_empresa]}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_linha: `${[this.tabela.id_linha]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        chegada: `${this.quadrohorario.chegada}`,
        chegada_virada_do_dia: `${this.quadrohorario.chegada_virada_do_dia}`,
        saida: `${this.quadrohorario.saida}`,
        saida_virada_do_dia: `${this.quadrohorario.saida_virada_do_dia}`,
        id_legenda: `${[this.quadrohorario.id_legenda]}`,
        id_funcionario_cadastro: `${[this.user.id_funcionario]}`,
        id_funcionario_alteracao: `${[this.user.id_funcionario]}`,
        id_sentido: `${[this.quadrohorario.id_sentido]}`, // id legenda da programação
        local_id: `${[this.quadrohorario.local_id]}`, // id legenda da programação
        status: `${[this.quadrohorario.status]}`, // id legenda da programação
        dt_vigencia: `${[this.tabela.dt_vigencia]}`,
      };

      const url = `${baseApiUrl}/planejamento/escala/quadrohorario`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
          this.resetQuadroHorario();
          this.loadQuadroHorario();
        })
        .catch(showError);
    },

    async loadQuadroHorario() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_tabela: `${[this.tabela.id]}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/quadrohorario/busca`;

      await axios
        .get(url, { params })
        .then((res) => {
          this.quadrohorarios = res.data.map((qh) => {
            return { ...qh };
          });
        })
        .catch(showError);
    },

    async loadQuadroHorario1818() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_tabela: `${[this.tabela.id]}`,
      };

      const url = `${baseApiUrl}/planejamento/escala/quadrohorario/busca`;

      try {
        const res = await axios.get(url, { params });

        //console.log("Resposta da API:", res.data);

        // Como você só espera um motorista, diretamente atribui o valor
        this.quadrohorarios = [res.data]; // Colocando dentro de um array
      } catch (error) {
        console.error("Erro ao carregar motoristas:", error);
      }
    },

    ///

    editTabela(tabela) {
      this.tabela = { ...tabela };
      this.loadBuscaMotorista1();
      this.loadBuscaCobrador1();
      this.loadVeiculo();
    },

    editQuadroHorario(quadrohorario) {
      this.quadrohorario = { ...quadrohorario };
    },

    resetTabela() {
      (this.tabela.id = ""), (this.tabela.carro = "");
      this.tabela.tabela = "";
      this.tabela.registro_mt1 = "";
      this.tabela.registro_mt2 = "";
      this.tabela.registro_cob1 = "";
      this.tabela.registro_cob2 = "";
      this.tabela.motorista_tempo_minuto = "";
      //this.tabela.entrega_feria=''
      this.tabela.cobrador_tempo_minuto = "";
      this.tabela.jornada_inicio = "";
      this.tabela.jornada_termino = "";
      this.tabela.linha_inicio = "";
      this.tabela.linha_termino = "";
      (this.tabela.refeicao_inicio = ""),
        (this.tabela.refeicao_termino = ""),
        (this.motoristas1 = []),
        (this.motoristas2 = []),
        (this.cobradores1 = []),
        (this.cobradores2 = []),
        (this.veiculos = []),
        this.loadTabelas();
    },

    resetQuadroHorario() {
      this.quadrohorario.id = "";
      this.quadrohorario.chegada = "";
      this.quadrohorario.saida = "";
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadTipoDia();
    this.loadPeriodo();
    this.loadSentido();
    this.loadLocal();
    this.loadLegenda();
    this.getTipoDeFolgaMot1();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}
</style>
